module.exports = __webpack_public_path__ + "img/1538100753.e4219231.jpg";